(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.teacheraccess = skyward.teacheraccess || {};

        var teacherAccessTileFilter = "#TeacherAccessTileFilter";
        var teacherAccessGrouping = "#TeacherAccessGrouping";
        var teacherAccessDailyAttendanceOptions = "#TeacherAccessDailyAttendanceOptions";
        var attendanceModeSelector = "#AttendanceModeSelector";

        var init = function (selector)
        {
            skyward.teacheraccess.enableControls(selector); 
        };

        skyward.teacheraccess.teacherAccessSectionsRadioSetChange = function (event)
        {
            var data = event.data; 
            skyward.teacheraccess.disableControls(data.selector);

            var postData = {};
            postData[data.id] = skyward.controls.getValue($(this));
            var actionArea = $(this).parents().data().area;
            var actionController = $(this).parents().data().controller;

            skyward.teacheraccess.fireTeacherAccessSettingsChangeAjax(data.actionMethod, postData, actionArea, actionController, data.selector);
        };

        skyward.teacheraccess.teacherAccessAttendanceModeChange = function ()
        {
            var idValue = $(this).val();
            var actionArea = $(this).data().area;
            var actionController = $(this).data().controller;

            skyward.teacheraccess.fireTeacherAccessSettingsChangeAjax("SetAttendanceMode", { "AttendanceModeSelector": idValue }, actionArea, actionController);
        };

        skyward.teacheraccess.disableControls = function (selector)
        {
            selector = selector || 'html';

            var teacherAccess = $(selector);
            teacherAccess.find(teacherAccessTileFilter).off('change', skyward.teacheraccess.teacherAccessSectionsRadioSetChange);
            teacherAccess.find(teacherAccessGrouping).off('change', skyward.teacheraccess.teacherAccessSectionsRadioSetChange);
            teacherAccess.find(teacherAccessDailyAttendanceOptions).off('change', skyward.teacheraccess.teacherAccessSectionsRadioSetChange);
            teacherAccess.find(attendanceModeSelector).off('change', skyward.teacheraccess.teacherAccessAttendanceModeChange);
        };

        skyward.teacheraccess.enableControls = function (selector)
        {
            selector = selector || 'html';

            var teacherAccess = $(selector);
            teacherAccess.find(teacherAccessTileFilter).on('change', { id: "TeacherAccessTileFilter", actionMethod: "SetTeacherAccessTileFilter", selector: selector }, skyward.teacheraccess.teacherAccessSectionsRadioSetChange);
            teacherAccess.find(teacherAccessGrouping).on('change', { id: "TeacherAccessGrouping", actionMethod: "SetTeacherAccessGrouping", selector: selector }, skyward.teacheraccess.teacherAccessSectionsRadioSetChange);
            teacherAccess.find(teacherAccessDailyAttendanceOptions).on('change', { id: "TeacherAccessDailyAttendanceOptions", actionMethod: "SetTodayOrPreviousWeekGrouping", selector: selector },
                skyward.teacheraccess.teacherAccessSectionsRadioSetChange);
            teacherAccess.find(attendanceModeSelector).on('change', skyward.teacheraccess.teacherAccessAttendanceModeChange);
        };

        skyward.teacheraccess.fireTeacherAccessSettingsChangeAjax = function (actionMethod, postData, actionArea, actionController, selector)
        {        
            $.ajax(
                {
                    url: skyward.global.virtualDir + actionArea + "/" + actionController + "/" + actionMethod,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    location.reload(true);
                },
                error: function ()
                {
                    skyward.teacheraccess.enableControls(selector);
                }
            });
        };

        var staffClassSettingPopup = function ()
        {
            var button = $(this).find(".staffClassSettingsButton");
            var data = button.data();

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Staff/StaffClassSetting/StaffClassSettingPopup",
                    type: "POST",
                    dataType: "viewparthtml",
                    activityIndicator: { silent: true },
                    data: data
                });
            };

            var buttons = [];
            buttons.push({
                id: "saveStaffClassSettingPopup", text: "Save", click: function ()
                {
                    var nickname = skyward.controls.getValue(dialog.content.find("#ClassNickname"));
                    var additionalSaveData = {};

                    if (dialog.content.find("#HideIndividualSectionsOnClassList").length > 0)
                    {
                        additionalSaveData.hideIndividualSectionsOnClassList = skyward.controls.getValue(dialog.content.find("#HideIndividualSectionsOnClassList"));
                    }
                    updateStaffSettings(button, nickname, additionalSaveData);
                    dialog.close();
                }, icon: "Save"
            });
            buttons.push({ id: "closeStudentGradeBucketIndicatorPopup", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" });

            var dialog = skyward.modalLayer.showDialog('Class Settings', buildPopup(), buttons, { anchorTo: button });

        };

        var updateStaffSettings = function(button, nickname, additionalSaveData)
        {
            var data = button.data();
            var saveData = $.extend({}, data, additionalSaveData);
            saveData.classNickname = nickname;
            var browse = button.parents(".browse");

            $.ajax({
                url: skyward.global.virtualDir + "Staff/StaffClassSetting/SaveStaffClassSetting",
                type: "POST",
                dataType: "JSON",
                data: saveData,
                success: async function (saveReturnData)
                {
                    if (saveReturnData.requiresRefresh)
                    {
                        location.reload();
                    }
                    else
                    {
                        var settingsButtonWrapper = button.parent("div");
                        var header = settingsButtonWrapper.siblings(".browseTileHeaderField");
                        var originalValue = header.html();
                        if (originalValue != saveReturnData.newDisplayValue)
                        {
                            await header.viewpartHtml(saveReturnData.newDisplayValue);
                            flashUpdateCell(header, FLASH_COLOR, FLASH_ANIMATION_DURATION);

                            var textBox = header.siblings(".staffNicknameTextBox").first();
                            textBox.data("originalValue", saveReturnData.newDisplayValue);
                            skyward.controls.setValue(textBox, saveReturnData.newDisplayValue);
                            settingsButtonWrapper.parents(".staffNicknameHeaderField").first().addClass("hasNickname");

                            if (data.groupByTypeCode == "S")
                            {
                                browse.find(".classGroup .browseTileBodyFieldValue[data-section-id='" + data.foreignKeyId +"']").each(async function ()
                                {
                                    var classGroupBrowseTileBodyFieldValue = $(this);
                                    var newText = classGroupBrowseTileBodyFieldValue.text().replace(originalValue, saveReturnData.newDisplayValue);
                                    await classGroupBrowseTileBodyFieldValue.viewpartHtml(newText);
                                    flashUpdateCell(classGroupBrowseTileBodyFieldValue, FLASH_COLOR, FLASH_ANIMATION_DURATION);

                                });
                            }
                        }
                    }
                }
            });
        };

        var FLASH_COLOR = "#c9f0c9";
        var FLASH_ANIMATION_DURATION = 1000;
        var flashUpdateCell = function (cell, flashUpdateCellColor, flashUpdateCellDuration)
        {
            if (cell.is(':animated')) {
                return;
            }

            var oldColor = cell.css("background-color");
            cell.css("background-color", flashUpdateCellColor);
            cell.animate({ backgroundColor: oldColor }, { duration: flashUpdateCellDuration });
        };

        var massEditStaffClassNickname = function ()
        {
            var button = $(this);
            var browse = button.parents(".browse").first();
            var textBoxes = browse.find(".staffNicknameTextBox");
            button.hide();
            browse.find(".massSaveNickname").show();
            browse.find(".massCancelNickname").show();

            skyward.changeTracking.setUpChangeTracking(browse);
            $.each(textBoxes, function()
            {
                var textBox = $(this);
                textBox.on('click', function (event)
                {
                    $(this).select();
                });
                textBox.show();
                textBox.siblings().hide();
            });
        };

        var massSaveStaffClassNickname = function ()
        {
            var button = $(this);
            var browse = button.parents(".browse").first();
            var textBoxes = browse.find(".staffNicknameTextBox");
            button.hide();
            browse.find(".massEditNickname").show();
            browse.find(".massCancelNickname").hide();
            browse.find(".classGroupPopupButtonWrapper").show();
            $.each(textBoxes, function()
            {
                var textBox = $(this);
                var settingsButton = textBox.siblings(".staffClassSettingsButtonWrapper").first().find(".staffClassSettingsButton");
                var nickname = skyward.controls.getValue(textBox);
                var additionalSaveData = {}
                if (browse.find(".classGroupPopupButtonWrapper").length > 0)
                {
                    additionalSaveData.fromMassEditClassNicknames = true;
                }

                if (nickname != textBox.data("originalValue"))
                {
                    updateStaffSettings(settingsButton, nickname, additionalSaveData);
                }
                textBox.hide();
                textBox.siblings(".staffClassSettingsButtonWrapper, .browseTileHeaderField").show();
                skyward.tileBrowse.setupClickEvent(textBox.parents(".browseTileContainer").first());
            });
            skyward.changeTracking.clearDirtyList(browse.attr("id"));  
        };

        var massCancelStaffClassNickname = function ()
        {
            var button = $(this);
            var browse = button.parents(".browse").first();
            var textBoxes = browse.find(".staffNicknameTextBox");
            
            button.hide();
            browse.find(".massEditNickname").show();
            browse.find(".massSaveNickname").hide();
            browse.find(".classGroupPopupButtonWrapper").show();
            $.each(textBoxes, function()
            {
                var textBox = $(this);
                var nickname = skyward.controls.getValue(textBox);

                if (nickname != textBox.data("originalValue"))
                {
                    skyward.controls.setValue(textBox, textBox.data("originalValue"));
                }
                textBox.hide();
                textBox.siblings(".staffClassSettingsButtonWrapper, .browseTileHeaderField").show();
                skyward.tileBrowse.setupClickEvent(textBox.parents(".browseTileContainer").first());

            });
            skyward.changeTracking.clearDirtyList(browse.attr("id"));
        };

        var classGroupInfoPopup = function ()
        {

            var dialog = skyward.modalLayer.showDialog('Class Group Information', "<div>Class group is hiding individual sections from class list</div>", [], { anchorTo: $(this) });
        };

        var events =
        {
            'StaffClassSettingPopup': staffClassSettingPopup,
            'massEditStaffClassNickname': massEditStaffClassNickname,
            'massSaveStaffClassNickname': massSaveStaffClassNickname,
            'massCancelStaffClassNickname': massCancelStaffClassNickname,
            'classGroupInfoPopup': classGroupInfoPopup, 
        };

        // TODO: When this call is converted to being ViewPart specific, add skyward.ui.tileBrowse.ts as a dependency and remove both files from the bundle
        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('teacheraccess', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);